export default Vue => {
  Vue.filter('toLocalString', val => {
    if (val) {
      if (toString.call(val) === '[object Array]') {
        const [v, p] = val
        if (v) {
          const f = v.toFixed(p)
          return f.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        }
        return '0'
      }
      const t = val.toString()
      return t.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }
    return '0'
  })
}
